import React, { FC, useState, useRef, useEffect } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { truncateTwoLines, truncateFiveLines } from './style.ve.css';

type LinesToTruncate = 'TWO' | 'FIVE';

const linesNumToStyle = {
  TWO: truncateTwoLines,
  FIVE: truncateFiveLines,
};

interface TruncatedTextProps {
  text?: string;
  linesToTruncate: LinesToTruncate;
}

export const TruncatedText: FC<TruncatedTextProps> = ({ text, linesToTruncate }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const textElement = textRef.current;
    if (textElement) {
      setIsTruncated(textElement.scrollHeight > textElement.clientHeight);
    }
  }, [text]);

  return (
    <Stack direction="column" gap="2" color="bodySecondary">
      <Text ref={textRef} className={isExpanded ? '' : linesNumToStyle[linesToTruncate]} whiteSpace="preWrap">
        {text}
      </Text>
      {isTruncated && (
        <Text cursor="pointer" decoration="underline" onClick={() => setIsExpanded((prevState) => !prevState)}>
          <I18n k={`brief_preview_drawer.${isExpanded ? 'show_less' : 'read_more'}`} />
        </Text>
      )}
    </Stack>
  );
};
